import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import HeroBanner from "./components/HeroBanner";
import DailyHot from "./components/DailyHot";
import LatestNews from "./components/LatestNews";
import CategoryNav from "./components/CategoryNav";
import CtaSection from "./components/CtaSection";

const homepageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "吃瓜网 - 实时吃瓜爆料平台",
  "description": "吃瓜网站汇聚吃瓜网每日大赛与实时吃瓜爆料平台，全网最全黑料、独家八卦持续更新。免费吃瓜第一站，网红大瓜正能量不打烊。",
  "url": "http://claekqe.cn/",
  "isPartOf": {
    "@type": "WebSite",
    "name": "吃瓜网",
    "url": "http://claekqe.cn/"
  }
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "吃瓜网是什么？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "吃瓜网是一个实时吃瓜爆料平台，汇聚吃瓜网每日大赛，提供全网最全的明星八卦、网红黑料、社会热点等最新爆料内容。作为免费吃瓜第一站，我们致力于为用户提供最新最全面的吃瓜内容。"
      }
    },
    {
      "@type": "Question",
      "name": "吃瓜网的内容多久更新一次？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "吃瓜网实行全天候实时更新机制，编辑团队24小时追踪娱乐圈、网红圈和社会热点，确保第一时间为用户带来最新爆料。每日大赛板块更是每天精选当日最热吃瓜内容。"
      }
    },
    {
      "@type": "Question",
      "name": "如何在吃瓜网上投稿爆料？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "您可以通过吃瓜网关于我们页面的联系方式向我们投稿爆料。我们欢迎各方提供真实可靠的爆料信息，经核实后将第一时间发布。投稿邮箱：hello@claekqe.cn。"
      }
    }
  ]
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(homepageSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>

      <Header />
      <main>
        <HeroBanner />
        <DailyHot />
        <LatestNews />
        <CategoryNav />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}